export enum FormControlTypeEnum {
    Checkbox,
    Select
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/FormControlTypeEnum.ts